<template>
  <div class="bull-detail">
    <el-dialog
      class="bull-dia"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :modal="true"
      :footer="null"
      top="60px"
      width="60%"
      custom-class="custom-dialog"
    >
      <div slot="title" class="title">
        <div class="title-name">{{ typeMap[bulletinType] }}</div>
        <div class="side-title"></div>
        <div class="handle-btn"><!-- <i class="el-icon-s-tools" slot="reference" style="cursor:pointer"></i> --></div>
        <div class="dialog-close-btn" @click="dialogVisible = false">X</div>
      </div>

      <!-- 展示变动信息 -->
      <div v-if="bulletinType == 'transfer'">
        <!-- <el-row style="margin-bottom:10px!important">
          <div>发布时间: {{ bulletin.时间 }} &nbsp;&nbsp;发布人: {{ bulletin.发布人 }}</div>
        </el-row>
        <el-row>
          <b>题目: {{ bulletin.标题 }}</b>
        </el-row>
        <el-row style="margin-bottom:10px!important"><b>详情:</b></el-row>
        <el-row style="margin-bottom:20px!important;white-space: pre-wrap;">{{ bulletin.详情 }}</el-row>
        <el-row type="flex" style="flex-wrap:wrap;line-height:2.5">
          <span v-if="bulletin.行业" style="margin-right:20px;"
            >行业: <el-tag size="mini" style="margin-left:10px">{{ bulletin.行业 }}</el-tag></span
          >
          <span v-if="bulletin.公司" style="margin-right:20px;"
            >公司: <el-tag size="mini" style="margin-left:10px">{{ bulletin.公司 }}</el-tag></span
          >
          <span v-if="bulletin.模块" style="margin-right:20px;"
            >职能模块:
            <el-tag v-for="(item, idx) in bulletin.模块.split(',')" :key="idx" size="mini" style="margin-left:10px">{{
              item
            }}</el-tag></span
          >
          <span v-if="bulletin.变动因素" style="margin-right:20px;"
            >变动因素: <el-tag size="mini" style="margin-left:10px">{{ bulletin.变动因素 }}</el-tag></span
          >
          <span v-if="bulletin.变动影响程度" style="margin-right:20px;"
            >变动影响程度: <el-tag size="mini" style="margin-left:10px">{{ bulletin.变动影响程度 }}</el-tag></span
          >
        </el-row> -->
        <el-row>
          <el-col :span="12" class="bull-item">
            <span class="bull-label bull-title">公&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;司：</span>
            <span class="bull-content">{{ bulletin.公司 || '--' }}</span>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label bull-title">模&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;块：</span>
            <span class="bull-content">{{ bulletin.模块 || '--' }}</span>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label bull-title">变动因素：</span>
            <span class="bull-content">{{ bulletin.变动因素 || '--' }}</span>
          </el-col>

          <template v-if="bulletin.变动因素 == '中高层人员变化'">
            <el-col :span="12" class="bull-item">
              <span class="bull-label bull-title">变动人员：</span>
              <span class="bull-content">{{ bulletin.变动人员 || '--' }}</span>
            </el-col>
            <el-col :span="12" class="bull-item">
              <span class="bull-label bull-title">离职公司：</span>
              <span class="bull-content">{{ bulletin.离职公司 || '--' }}</span>
            </el-col>
            <el-col :span="12" class="bull-item">
              <span class="bull-label bull-title">原公司职位：</span>
              <span class="bull-content">{{ bulletin.原公司职位 || '--' }}</span>
            </el-col>
            <el-col :span="12" class="bull-item">
              <span class="bull-label bull-title">入职公司：</span>
              <span class="bull-content">{{ bulletin.入职公司 || '--' }}</span>
            </el-col>
            <el-col :span="12" class="bull-item">
              <span class="bull-label bull-title">新公司职位：</span>
              <span class="bull-content">{{ bulletin.新公司职位 || '--' }}</span>
            </el-col>
          </template>

          <el-col :span="12" class="bull-item">
            <span class="bull-label bull-title">影响程度：</span>
            <span class="bull-content">{{ bulletin.变动影响程度 || '--' }}</span>
          </el-col>
          <el-col :span="24" class="bull-item">
            <span class="bull-label bull-title" :show-overflow-tooltip="true"
              >标&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;题：</span
            >
            <span class="bull-content">{{ bulletin.标题 }}</span>
          </el-col>
          <el-col :span="24" class="bull-item">
            <span class="bull-label bull-title">内&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;容：</span>
          </el-col>
          <el-col :span="24">
            <pre class="bull-content" style="margin-top:0;line-height:1.5;">{{ bulletin.详情 || bulletin.内容 }}</pre>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label bull-title">发布人：</span>
            <span class="bull-content">{{ bulletin.发布人 || '--' }}</span>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label bull-title">时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间：</span>
            <span class="bull-content">{{ bulletin.时间 }}</span>
          </el-col>
        </el-row>
      </div>
      <!-- 展示招聘信息详情(官网，其他) -->
      <div v-else-if="bulletinType == 'bd' && ['ofc', 'others'].indexOf(tabFrom) != -1" class="bulletin-jobs">
        <el-row>
          <el-col :span="12" class="bull-item">
            <span class="bull-label">公&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;司：</span>
            <span class="bull-content">{{ bulletin.公司 }}</span>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;域：</span>
            <span class="bull-content">{{ formatArr(bulletin.城市) }}</span>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label">职能模块：</span>
            <span class="bull-content">{{
              bulletin.模块 || (bulletin.新圆手细分职能 && bulletin.新圆手细分职能.join('，')) || '--'
            }}</span>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label">部&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;门：</span>
            <span class="bull-content">{{ bulletin.部门 || '--' }}</span>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label">工作年限：</span>
            <span class="bull-content">{{
              bulletin.工作经验.length == 2 ? `${bulletin.工作经验[0]}-${bulletin.工作经验[1]}年` : '不限'
            }}</span>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label">学历要求：</span> <span class="bull-content">{{ bulletin.学历要求 }}</span>
          </el-col>
          <el-col :span="24" class="bull-item">
            <span class="bull-label">岗位名称：</span> <span class="bull-content">{{ bulletin.标题 }}</span>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label">薪资范围：</span>
            <span v-if="bulletin.月薪范围 && bulletin.月薪范围 instanceof String" class="bull-content">{{
              bulletin.月薪范围
            }}</span>
            <span v-else-if="bulletin.月薪范围 && bulletin.月薪范围 instanceof Array" class="bull-content"
              >{{ bulletin.月薪范围[0] }}-{{ bulletin.月薪范围[1] }}</span
            >
            <span v-else>面议</span>
          </el-col>
          <el-col :span="24" class="bull-item">
            <div class="bull-label">岗位详情：</div>
            <pre class="bull-content">{{ bulletin.职位描述 }}</pre>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label">发布人：</span> <span v-if="tabFrom == 'ofc'" class="bull-content">官网</span>
            <span v-else-if="bulletin.来源 == 'liepin'" class="bull-content">猎聘</span>
            <span v-else class="bull-content">其他</span>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label">时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间：</span>
            <span class="bull-content">{{ getTime(bulletin.createdAt) }}</span>
          </el-col>
        </el-row>
      </div>
      <!-- 展示招聘信息（alpha） -->
      <div v-else-if="bulletinType == 'bd' && ['alpha'].indexOf(tabFrom) != -1" class="bulletin-jobs">
        <el-row>
          <el-col :span="12" class="bull-item">
            <span class="bull-label bull-title">公&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;司：</span>
            <span class="bull-content">{{ bulletin.公司 }}</span>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label bull-title">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;域：</span>
            <span class="bull-content">{{ (bulletin.地域 && bulletin.地域.join(' ')) || '--' }}</span>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label bull-title">模&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;块：</span>
            <span class="bull-content">{{ bulletin.模块 }}</span>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label bull-title">部&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;门：</span>
            <span class="bull-content">{{ bulletin.部门 }}</span>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label bull-title">岗位类型：</span>
            <span class="bull-content">{{ bulletin.岗位类型 }}</span>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label bull-title">汇报上级：</span>
            <span class="bull-content">{{ bulletin.汇报上级 || '--' }}</span>
          </el-col>
          <el-col :span="24" class="bull-item">
            <span class="bull-label bull-title">岗位名称：</span>
            <span class="bull-content">{{ bulletin.岗位名称 }}</span>
          </el-col>
          <el-col :span="24" class="bull-item"> <span class="bull-label bull-title">岗位详情：</span> </el-col>
          <el-col :span="24">
            <pre class="bull-content">{{ bulletin.岗位详情 }}</pre>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label bull-title">发布人：</span> <span class="bull-content">{{ bulletin.发布人 }}</span>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label bull-title">时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间：</span>
            <span class="bull-content">{{ bulletin.时间 }}</span>
          </el-col>
        </el-row>
      </div>
      <!-- 展示新闻信息详情(全部，推荐，阿尔法新闻) -->
      <div v-else-if="bulletinType == 'others' && tabFrom != 'baidu'">
        <el-row>
          <el-col :span="24" class="bull-item">
            <span class="bull-label bull-title" :show-overflow-tooltip="true"
              >标&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;题：</span
            >
            <span class="bull-content">{{ bulletin.标题 }}</span>
          </el-col>
          <el-col :span="24" class="bull-item">
            <span class="bull-label bull-title" :show-overflow-tooltip="true"
              >公&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;司：</span
            >
            <span class="bull-content">{{ bulletin.公司 || '' }}</span>
          </el-col>
          <el-col :span="24" class="bull-item">
            <span class="bull-label bull-title">内&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;容：</span>
          </el-col>
          <el-col :span="24">
            <pre class="bull-content">{{ bulletin.详情 || bulletin.内容 }}</pre>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label bull-title">发布人：</span> <span class="bull-content">{{ bulletin.发布人 }}</span>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label bull-title">时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间：</span>
            <span class="bull-content">{{ bulletin.时间 }}</span>
          </el-col>
        </el-row>
        <!-- <el-row style="margin-bottom:10px!important">
          <span class="bull-label">发布时间:{{ bulletin.时间 }} &nbsp;&nbsp;发布人:</span>
        </el-row>
        <el-row>
          <span class="bull-label">发布人:</span>
          <span class="bull-content">{{ bulletin.发布人 }}</span>
        </el-row>
        <el-row>
          <b>题目: {{ bulletin.标题 }}</b>
        </el-row>
        <el-row style="margin-bottom:10px!important"><b>详情:</b></el-row>
        <el-row style="margin-bottom:20px!important;white-space: pre-wrap;">{{ bulletin.内容 }}</el-row> -->
      </div>
      <!-- 展示新闻信息详情(百度) -->
      <div v-else-if="bulletinType == 'others' && tabFrom == 'baidu'">
        <el-row style="margin-bottom:10px!important">
          <div>发布时间: {{ bulletin.发布时间.replace(/:/gi, '-') }} &nbsp;&nbsp;来源: 百度</div>
        </el-row>
        <el-row>
          <b>题目: {{ bulletin.标题 }}</b>
        </el-row>
        <el-row style="margin-bottom:10px!important"><b>详情:</b></el-row>
        <el-row style="margin-bottom:20px!important;white-space: pre-wrap;">{{ bulletin.简介 }}</el-row>
        <el-row>
          <span>原文链接: {{ bulletin.url }}</span>
        </el-row>
      </div>
      <!-- 展示融资信息 -->
      <div v-else-if="bulletinType == 'financing'">
        <el-row>
          <el-col :span="24" class="bull-item">
            <span class="bull-label bull-title" :show-overflow-tooltip="true"
              >标&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;题：</span
            >
            <span class="bull-content">{{ bulletin.标题 }}</span>
          </el-col>
          <el-col :span="24" class="bull-item">
            <span class="bull-label bull-title" :show-overflow-tooltip="true"
              >公&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;司：</span
            >
            <span class="bull-content">{{ bulletin.公司 || '' }}</span>
          </el-col>
          <el-col :span="24" class="bull-item">
            <span class="bull-label bull-title">疑似联系方式：</span>
            <pre class="bull-content">{{ bulletin.疑似联系方式 }}</pre>
          </el-col>
          <el-col :span="24" class="bull-item">
            <span class="bull-label bull-title">内&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;容：</span>
          </el-col>
          <el-col :span="24">
            <pre class="bull-content">{{ bulletin.详情 || bulletin.内容 }}</pre>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label bull-title">发布人：</span> <span class="bull-content">{{ bulletin.发布人 }}</span>
          </el-col>
          <el-col :span="12" class="bull-item">
            <span class="bull-label bull-title">时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间：</span>
            <span class="bull-content">{{ bulletin.时间 }}</span>
          </el-col>
        </el-row>
        <!-- <el-row style="margin-bottom:10px!important">
          <span class="bull-label">发布时间:{{ bulletin.时间 }} &nbsp;&nbsp;发布人:</span>
        </el-row>
        <el-row>
          <span class="bull-label">发布人:</span>
          <span class="bull-content">{{ bulletin.发布人 }}</span>
        </el-row>
        <el-row>
          <b>题目: {{ bulletin.标题 }}</b>
        </el-row>
        <el-row style="margin-bottom:10px!important"><b>详情:</b></el-row>
        <el-row style="margin-bottom:20px!important;white-space: pre-wrap;">{{ bulletin.内容 }}</el-row> -->
      </div>
      <div style="text-align:right;">
        <el-button
          v-if="tabFrom == 'alpha' || tabFrom == 'bull'"
          type="primary"
          size="mini"
          style="margin-right:20px;background:#85AFDA;border-color:#85AFDA"
          @click="showEditBulletin()"
        >
          修改
        </el-button>
        <el-button
          type="primary"
          size="mini"
          style="background:#85AFDA;border-color:#85AFDA"
          @click="showAddBulletin()"
        >
          新增一条
        </el-button>
        <el-tooltip v-if="bulletinType == 'bd'" content="可直接把该招聘信息新建为项目" placement="top-start">
          <el-button
            type="primary"
            size="mini"
            style="background:#85AFDA;border-color:#85AFDA"
            @click="
              goto(
                `#/createProject20?cmp=${bulletin.公司}&kehu=${bulletin.发布人 || ''}&job=${bulletin.岗位名称 ||
                  bulletin.标题}&detail=${bulletin.职位描述 || bulletin.岗位详情 || ''}`,
              )
            "
          >
            一键建项
          </el-button>
        </el-tooltip>
      </div>
      <bulletinCommit ref="bulletinCommit" :bulletinId="bulletin._id"></bulletinCommit>
    </el-dialog>
    <bulletinAdd ref="bulletinAdd" :handle-save="handleSave" :handle-update="handleUpdate"></bulletinAdd>
  </div>
</template>
<script>
import bulletinAdd from './bulletinAdd'
import bulletinCommit from './bulletinCommit'
const dateFormat = require('dateformat')

export default {
  components: { bulletinAdd, bulletinCommit },
  data() {
    return {
      typeMap: {
        transfer: '变动信息',
        bd: '招聘信息',
        others: '其他情报',
      },
      bulletin: {},
      tabFrom: 'bull',
      bulletinType: 'transfer',
      dialogVisible: false,
    }
  },
  methods: {
    getTime(time) {
      return time ? dateFormat(time, 'yyyy-mm-dd HH:MM') : ''
    },
    show(bulletin, bulletinType, tabFrom) {
      this.bulletin = bulletin || {}
      this.bulletinType = bulletinType || bulletin.type || 'transfer'
      this.tabFrom = tabFrom || 'alpha'
      this.dialogVisible = true
      this.$refs.bulletinCommit && this.$refs.bulletinCommit.init && this.$refs.bulletinCommit.init()
    },
    formatArr(arr) {
      if (Array.isArray(arr)) return arr.toString()
      return arr
    },
    showAddBulletin: async function() {
      this.$refs.bulletinAdd.show({ formData: {}, bulletinsType: this.bulletin.type })
    },
    showEditBulletin: async function() {
      this.$refs.bulletinAdd.show({ formData: Object.assign({}, this.bulletin), bulletinsType: this.bulletin.type })
    },
    handleSave: function(formData) {
      this.dialogVisible = false
    },
    handleUpdate: function(formData) {
      this.bulletin = formData || {}
      this.dialogVisible = false
      this.$parent.$parent.handleUpdate && this.$parent.$parent.handleUpdate(formData)
    },
    goto(url) {
      window.open(url)
    },
  },
}
</script>
<style>
.bull-dia .el-dialog__body {
  padding: 10px 30px;
}
.bull-item {
  padding-bottom: 10px;
}
.bull-label {
  color: #9b9696;
}
.bull-content {
  color: black;
}
pre.bull-content {
  white-space: pre-wrap;
  line-height: 35px;
  padding-left: 27px;
}
.bulletin-jobs .bull-label {
  display: inline-block;
  width: 75px;
}
</style>
<style scoped src="../../../company/statistics/css/commonCompany.css"></style>
